module.exports = {
      id: "business-usage",
      viewBox: "0 0 28.79 24.369",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#business",
      toString: function () {
        return this.url;
      }
    }